// Collection tiles for the Super Admin reports.
// `totals` = API `totalsByCategory`: { registeredUpi, nonRegisteredUpi, cash, grandTotal } each { count, amount }.
// Server computes them over the whole selected range (not just the visible page).
import React from 'react';
import { Box, Paper, Typography } from '@mui/material';

const fmt = (n) => `₹${(Number(n) || 0).toLocaleString('en-IN', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}`;

const CollectionTotals = ({ totals, showGrandTotal = false, sx }) => {
  if (!totals) return null;
  const items = [
    ...(showGrandTotal ? [{ key: 'grandTotal', label: 'GRAND TOTAL', color: 'success.main' }] : []),
    { key: 'registeredUpi', label: 'COLLECTION REGISTERED UPI', color: 'primary.main' },
    { key: 'nonRegisteredUpi', label: 'COLLECTION NON REGISTERED UPI', color: 'info.main' },
    { key: 'cash', label: 'COLLECTION CASH', color: 'warning.main' },
  ];
  return (
    <Box sx={{ display: 'flex', gap: 2, flexWrap: 'wrap', my: 1, ...sx }}>
      {items.map(({ key, label, color }) => {
        const t = totals[key] || {};
        return (
          <Paper key={key} variant="outlined" sx={{ px: 2, py: 1, minWidth: 220, borderLeft: 4, borderLeftColor: color }}>
            <Typography variant="caption" color="text.secondary" sx={{ fontWeight: 600 }}>{label}</Typography>
            <Typography variant="h6" sx={{ lineHeight: 1.3 }}>{fmt(t.amount)}</Typography>
            <Typography variant="caption" color="text.secondary">
              {t.count || 0} transaction{t.count === 1 ? '' : 's'}
            </Typography>
          </Paper>
        );
      })}
    </Box>
  );
};

export default CollectionTotals;
